module.exports = __webpack_public_path__ + "img/RM2.a22420b6.jpeg";